/**
 *获取项目id
 */
export const GetSiteIdMixin = {
    data() {
        return {
            currentSiteId: "",
            currentSiteName: "",
            currentAreaId: "",
            currentSiteIds: '',
            currentSiteType: '',
            siteOnly: false,
            autoLoadInit: false,
            timeOut: 1000, // 一秒延时
            timer: null,
            showSite: true
        }
    },
    mounted() {
        // this.$bus.$emit('st', '')
        setTimeout(() => {
            this.$bus.$emit('showSite', "show", this.showSite);
            this.$bus.$emit('isCheckbox', 'show', false);
            this.$bus.$emit('siteOnly', 'set', Boolean(this.siteOnly));
        }, 100);

        this.currentSiteId = window.sessionStorage.getItem("siteId")
        this.currentSiteName = window.sessionStorage.getItem('siteName')
        this.currentAreaId = window.sessionStorage.getItem('siteAreaId')
        this.currentSiteIds = window.sessionStorage.getItem("sites")
        this.currentSiteType = window.sessionStorage.getItem("siteType")
        window.addEventListener('setItem', (e) => {
            this.currentSiteName = sessionStorage.getItem('siteName')
            this.currentAreaId = sessionStorage.getItem('siteAreaId')
            this.currentSiteType = sessionStorage.getItem("siteType")
            if (e.key == 'siteId') {
                this.currentSiteId = window.sessionStorage.getItem("siteId")
            }
            if (e.key == 'sites') {
                this.currentSiteIds = window.sessionStorage.getItem("sites")
            }

        })
    },
    beforeDestroy() {
        this.$bus.$emit('siteOnly', 'set', false);
    },
    methods: {
        getTreeCurrentId() {
            if (!this.currentSiteId) { return [null, null] } else {
                var rex = /^[a-zA-Z]/
                if (rex.test(this.currentSiteId)) {
                    if (this.currentSiteId[0] == 'A') {
                        //  返回数组的第一个值为2   区域id
                        return [2, this.currentSiteId.split('_')[1]]
                    } else if (this.currentSiteId[0] == 'R') {
                        //  返回数组的第一个值为3   流域id
                        return [3, this.currentSiteId.split('_')[1]]
                    } else if (this.currentSiteId[0] == 'C') {
                        //  返回数组的第一个值为4   公司id
                        return [4, this.currentSiteId.split('_')[1]]
                    } else if (this.currentSiteId[0] == 'G') {
                        //  返回数组的第一个值为4   公司id
                        return [5, this.currentSiteId.split('_')[1]]
                    }
                } else {
                    // 返回数组的第一个值为1    站点id
                    return [1, this.currentSiteId]
                }
            }
        },
        getTreeCurrentIds() {
            if (!this.currentSiteIds) { return [null, null] } else {
                var rex = /^[a-zA-Z]/
                var currentSiteIds = this.currentSiteIds.split(',').filter(Boolean)
                var ids = []
                currentSiteIds.forEach(element => {
                    if (element && !rex.test(element)) {
                        ids.push(element)
                    }
                });
                ids = ids.join(',')
                // 返回数组的第一个值为1    站点id
                return [1, ids]
            }
        },
        delayLoadData() {
            clearTimeout(this.timer)  //清除延迟执行
            this.timer = setTimeout(() => {   //设置延迟执行
                if (this.$refs.colControl) {
                    this.$refs.colControl.firstState = true
                }
                this.loadData(1)
            }, this.timeOut)
        }
    }
}